import React from 'react'
import EducationSectionBlock from '../../components/Education/EducationSectionBlock'
import EducationLayout from '../../components/Education/EducationLayout'
import {
  ID_ONE_ON_ONE,
  ID_MG_CERTIFICATIONS,
  ID_MG_MEMBERSHIP,
  SKU_MG_ART_IN_PERSON,
  SKU_MG_ART_VIRTUAL,
  SKU_MG_SPEC_IN_PERSON,
  SKU_MG_SPEC_VIRTUAL,
  SKU_MG_MSTR_IN_PERSON,
  SKU_MG_MSTR_VIRTUAL
} from 'src/constants'
import { useProductPrice } from '../../customHooks/useProductPrice'
import { useAdditionalProductPrice } from 'src/customHooks/useAdditionalProductPrice'
import additionalEducationalResources from '../../components/Education/data/additionalEducationalResources.json'
import additionalOnlineAcademyResourcesMG from '../../components/Education/data/additionalOnlineAcademyResourcesMG.json'

export default function LearningMG() {
  const { prices: matrixGoldCertifications } = useProductPrice(ID_MG_CERTIFICATIONS)
  const { additionalResources: matrixGoldOnlineAcademy } = useAdditionalProductPrice(
    additionalOnlineAcademyResourcesMG,
    [ID_MG_MEMBERSHIP]
  )
  const { additionalResources } = useAdditionalProductPrice(additionalEducationalResources, [
    ID_ONE_ON_ONE,
    ID_MG_MEMBERSHIP
  ])

  return (
    <EducationLayout>
      <EducationSectionBlock
        title='education.certifications.title'
        descriptions={[
          'education.certifications.matrixGoldDescription',
          'education.certifications.matrixGoldDescription2'
        ]}
        pricesData={matrixGoldCertifications}
        sectionData={[
          {
            sku: SKU_MG_ART_IN_PERSON,
            imageUrl: 'https://meteor.stullercloud.com/das/134500926?wid=700',
            descriptionId: 'education.matrixGoldArtisanInPerson'
          },
          {
            sku: SKU_MG_ART_VIRTUAL,
            imageUrl: 'https://meteor.stullercloud.com/das/139782901?wid=700',
            descriptionId: 'education.matrixGoldArtisanVirtual'
          },
          {
            sku: SKU_MG_SPEC_IN_PERSON,
            imageUrl: 'https://meteor.stullercloud.com/das/134500934?wid=700',
            descriptionId: 'education.matrixGoldSpecialistInPerson'
          },
          {
            sku: SKU_MG_SPEC_VIRTUAL,
            imageUrl: 'https://meteor.stullercloud.com/das/139782445?wid=700',
            descriptionId: 'education.matrixGoldSpecialistInVirtual'
          },
          {
            sku: SKU_MG_MSTR_IN_PERSON,
            imageUrl: 'https://meteor.stullercloud.com/das/139782899?wid=700',
            descriptionId: 'education.matrixGoldMasterInPerson'
          },
          {
            sku: SKU_MG_MSTR_VIRTUAL,
            imageUrl: 'https://meteor.stullercloud.com/das/139782891?wid=700',
            descriptionId: 'education.matrixGoldMasterVirtual'
          }
        ]}
      />
      <EducationSectionBlock
        title='education.onlineAcademy.titleMG'
        pricesData={matrixGoldOnlineAcademy}
        sectionData={[
          {
            imageUrl: 'https://meteor.stullercloud.com/das/134498425?wid=700'
          }
        ]}
      />
      <EducationSectionBlock
        title='education.additionalResources.title'
        descriptions={['education.additionalResources.matrixGoldDescription']}
        pricesData={additionalResources}
        sectionData={[
          { imageUrl: 'https://meteor.stullercloud.com/das/134498046?wid=700' },
          { imageUrl: 'https://meteor.stullercloud.com/das/134498417?wid=700' }
        ]}
      />
    </EducationLayout>
  )
}
